import { render } from "./ShoppingCartDiscountsDetail.vue?vue&type=template&id=dec96a98&scoped=true&ts=true"
import script from "./ShoppingCartDiscountsDetail.vue?vue&type=script&lang=ts"
export * from "./ShoppingCartDiscountsDetail.vue?vue&type=script&lang=ts"

import "./ShoppingCartDiscountsDetail.vue?vue&type=style&index=0&id=dec96a98&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec96a98"]])

export default __exports__